import GoogleIcon from '@mui/icons-material/Google';
import { Box } from './mui-system';
import type { SearchProvider } from '../../../api/src/search-metrics/search-metrics.types';
export const sourceNames: Record<SearchProvider, string> = { google: 'Google', yandex: 'Яндекс' };
export const sourceColors: Record<SearchProvider, string> = {
  google: '#4285f4',
  yandex: '#fc3f1d',
};
export function SourceIcon({ provider }: { provider: SearchProvider }) {
  return (
    <Box
      component="span"
      role="img"
      aria-label={sourceNames[provider]}
      sx={{
        width: 21,
        height: 21,
        borderRadius: '50%',
        bgcolor: provider === 'google' ? '#fff' : sourceColors[provider],
        color: provider === 'google' ? sourceColors[provider] : '#fff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontSize: 17,
        fontWeight: 500,
        lineHeight: 1,
        fontFamily: 'Arial, sans-serif',
      }}
    >
      {provider === 'google' ? <GoogleIcon sx={{ fontSize: 18 }} /> : 'Я'}
    </Box>
  );
}
